import axios from "axios";

export const fetcher = async (...props) => {
    const { data } = await axios(...props)
    return data;
}